module.exports = __webpack_public_path__ + "img/offline.df879be0.png";